import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const BAR_WIDTH = 40;

const styles = theme => ({
	root: {
		width: BAR_WIDTH,
		height: '24px',
		position: 'relative',
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between'
	},
	bar: {
		display: 'block',
		height: '4px',
		width: BAR_WIDTH,
		background: theme.palette.common.white,
		borderRadius: '4px',
		transition: 'width .25s linear',

		'&:after': {
			content: '""',
			display: 'block',
			position: 'absolute',
			height: '4px',
			width: 0,
			background: theme.palette.common.white,
			borderRadius: '4px',
			transition: 'width .25s linear',
			right: 0
		},

		'&$barOpen': {
			width: BAR_WIDTH,

			'&:after': {
				width: 0
			},

			'&:nth-child(1)': {
				transitionDelay: '.25s'
			},

			'&:nth-child(2)': {
				transitionDelay: '.33s',
				'&:after': {
					transitionDelay: '.08s'
				}
			},

			'&:nth-child(3)': {
				transitionDelay: '.41s',
				'&:after': {
					transitionDelay: '.16s'
				}
			}
		},

		'&$barClose': {
			width: 0,

			'&:after': {
				width: BAR_WIDTH
			},

			'&:nth-child(1)': {
				'&:after': {
					transitionDelay: '.25s'
				}
			},

			'&:nth-child(2)': {
				transitionDelay: '.08s',
				'&:after': {
					transitionDelay: '.33s'
				}
			},

			'&:nth-child(3)': {
				transitionDelay: '.16s',
				'&:after': {
					transitionDelay: '.41s'
				}
			}
		}
	},
	barOpen: {},
	barClose: {}
});

@withStyles(styles)
class HamburgerButton extends Component {

	render() {
		const { classes, onChange, open } = this.props;
		const barClasses = {
			[classes.bar]: true,
			[classes.barOpen]: open,
			[classes.barClose]: !open,
		};

		return (
			<div className={classes.root} onClick={onChange} data-tid="button-hamburger-button">
				<span className={classNames(barClasses)} />
				<span className={classNames(barClasses)} />
				<span className={classNames(barClasses)} />
			</div>
		);

	}

}

HamburgerButton.defaultProps = {
	open: true,
	onChange: () => {}
};

HamburgerButton.propTypes = {
	classes: PropTypes.object,
	open: PropTypes.bool,
	onChange: PropTypes.func
};

export default HamburgerButton;



// WEBPACK FOOTER //
// ./src/components/HamburgerButton/HamburgerButton.js